import service from "@/utils/request";
import * as apiRequest from "@/api/Type";
import {ModifyUser} from "@/api/Type";
const url = require("@/utils/data").url;

/**
 * 登录
 * @param data {apiRequest.LoginRequest}
 */
export const login = (data: apiRequest.LoginRequest) => {
    return service({
        url: url + "/user/login",
        method: "post",
        isToken: false,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 查询用户信息（不带id则查询当前用户ID）
 * @param data {apiRequest.QueryUserInfoRequest}
 */
export const queryUserInfo = (data?: apiRequest.QueryUserInfoRequest) => {
    return service({
        url: url + "/user/query/user/info",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 退出登录
 */
export const logout = () => {
    return service({
        url: url + "/user/logout",
        method: "post",
        isToken: true,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 获取用户列表
 * @param data {apiRequest.QueryUserList}
 */
export const queryUserList = (data: apiRequest.QueryUserList) => {
    return service({
        url: url + "/user/query/user/list",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}


/**
 * 修改当前用户信息
 * @param data  {apiRequest.ModifyUser}
 */
export const modifyUser = (data: apiRequest.ModifyUser) => {
    return service({
        url: url + "/user/modify/user",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 删除用户(管理员使用)
 * @param data {apiRequest.DelUser}
 */
export const delUser = (data: apiRequest.DelUser) => {
    return service({
        url: url + "/user/del/user",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 修改密码
 * @param data {apiRequest.ModifyUserPassword}
 */
export const modifyUserPassword = (data: apiRequest.ModifyUserPassword) => {
    return service({
        url: url + "/user/modify/password",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}
